export default __webpack_public_path__ + "static/media/beaconIcon.c6787e45.png";